import { render, staticRenderFns } from "./AlarmEditIcon.vue?vue&type=template&id=bfbae4ec"
import script from "./AlarmEditIcon.vue?vue&type=script&lang=js"
export * from "./AlarmEditIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports